import axios from "axios";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { QrReader } from "react-qr-reader";
import CONFIG from "../constanta/config";
import QRCode from "react-qr-code";

const PopupCheckData = (props) => {
  const [dataPayload, setDataPayload] = useState([]);
  const [popupConfirm, setPopupConfirm] = useState(false);
  const [isEarly, setIsEarly] = useState(true);
  const [listProfesi, setListProfesi] = useState([]);
  const [listPaket, setListPaket] = useState([]);
  const [seat, setSeat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm();


  const isValidEmail = (email) =>
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );


  const onSubmit = (data) => {
    setMsg("");
    setLoading(true);

    axios
      .get(
        CONFIG.URL +
          `/user/registration?email=${data.email}&phone=${data.phone}`
      )
      .then(function (response) {
        setLoading(false);
        if (response?.data?.status === "SUCCESS") {
          reset();
          setPopupConfirm(true);
          setDataPayload(response?.data?.data);
        } else {
          setMsg(response?.data?.message);
        }
      })
      .catch(function (error) {
        setLoading(false);
        setMsg("Something went wrong, please try again or contact admin");
      });
  };

  return (
    <>
      {loading && (
        <>
          <div className="flex flex-col justify-center items-center absolute z-[999999] top-0 left-0 w-screen h-screen bg-[#000000d6] text-white justify-start items-start font-semibold text-xl">
            Loading...
          </div>
        </>
      )}

      {popupConfirm && (
        <div className="absolute bg-[#00000080] w-screen min-h-screen z-[99999] flex justify-start items-start p-5">
          <div className="space-y-5 w-full h-full bg-white border-2 border-white rounded-lg p-4 flex flex-col justify-start items-start">
            <div className="flex justify-between w-full">
              <div className="text-lg font-bold pb-2 border-b border-black">
                Your Ticket
              </div>

              <div className="flex justify-center items-center">
                <button
                  onClick={() => setPopupConfirm(false)}
                  className="px-4 py-1 bg-transprent border-2 border-white rounded-lg text-white font-bold"
                >
                  BACK
                </button>
              </div>
            </div>

            {dataPayload?.map((item, key) => {
              return (
                <div key={key} className="border border-black rounded-lg p-4 w-full h-auto ">
                  <div className="mb-4">
                    <div className="capitalize">Name: {item.name}</div>
                    <div className="capitalize">Profession: {item.profession}</div>
                    <div>Package: {item.partisipation}</div>
                  </div>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={item.qr_code}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}

      <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
        <div className="absolute z-20 top-0 left-0 w-screen h-screen bg-[#000000d6]"></div>
        <div className="absolute py-5 z-50  top-0 left-0 w-screen h-auto flex flex-col justify-start items-center">
          <div className="flex flex-col space-y-2">
            <div className=" text-white text-center font-bold text-2xl uppercase">
              CHECK YOUR TICKET
            </div>
            {/* <div className=" text-white text-center font-semibold">
              Silahkan isi data
            </div> */}
          </div>
          <div className="h-auto flex flex-col w-full px-10  max-w-lg mt-10">
            <div className="mb-1">
              <div className="text-white mb-1">Email :</div>
              <input
                {...register("email", {
                  required: true,
                  validate: isValidEmail,
                })}
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-white border-2 border-white rounded-lg text-black"
              />
              {errors.email && (
                <span className="text-red-500 text-sm">
                  This field is required / invalid email format
                </span>
              )}
            </div>

            <div className="mb-1">
              <div className="text-white mb-1">Whatsapp Number :</div>
              <input
                {...register("phone", { required: true })}
                type="number"
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-white border-2 border-white rounded-lg text-black"
              />
              {errors.phone && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <div className="text-red-500 text-center mt-10">{msg}</div>
          </div>
          <div className="w-full flex justify-center items-center space-x-5 my-5">
            <button
              type="button"
              onClick={() => props.onClose()}
              className="min-w-[140px] px-10 py-2 bg-transprent border-2 border-white rounded-lg text-white font-bold"
            >
              CANCEL
            </button>

            <button
              type="sumbit"
              className="min-w-[160px] px-10 py-2 bg-white border-2 border-whiet rounded-lg text-[#fbda08] font-bold"
            >
              SUBMIT
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default PopupCheckData;
